import { useEffect, useState, setState } from 'react';
import logo from './logo.svg';
import './App.css';
import XIcon from '@mui/icons-material/X';
import About from './components/About';
import Main from './components/Main';
import BottomNav from './components/BottomNav';

function App() {

  const [user, setUser] = useState(null);

  if (user) {

  } else {
    return (
      <div className='App App-header'>
        <Main user={user} />
        <BottomNav />
      </div>
    )
  }
}

export default App;
